import { useEffect, useRef } from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import Dashboard from '../../components/Dashboard/Dashboard.tsx';
import Navbar from '../../components/Navbar/Navbar.tsx';
import { handleCleanupDrafts } from '../../fetchHooks/handleCleanupDrafts';
import { useIsLoggedIn } from '../../fetchHooks/useIsLoggedIn.ts';
import { useUserProfile } from '../../fetchHooks/useUserProfile.ts';
import Login from '../LoginPage/Login.tsx';

const RenderUserInfo = () => {
  const { t } = useTranslation();
  const { data: user, isLoading, error } = useUserProfile();

  if (isLoading) return <div>{t('common.loading')}</div>;
  if (error) return <div>{t('errors.genericError')}</div>;

  switch (user?.role) {
    case 'USER':
      return (
        <div className="app-container">
          <Dashboard user={user} />
        </div>
      );
    case 'MASTER':
      return (
        <div className="app-container">
          <Dashboard user={user} />
        </div>
      );

    default:
      return <p>{t('errors.genericError')}</p>;
  }
};

const Home = () => {
  const { t } = useTranslation();
  const { data, isPending } = useIsLoggedIn();
  const isLoggedIn = data?.loggedIn;
  const cleanupDone = useRef(false);

  // Run cleanup-drafts once when user logs in
  useEffect(() => {
    if (isLoggedIn && !cleanupDone.current) {
      cleanupDone.current = true;
      handleCleanupDrafts(() => {
        console.log('Cleaned up old draft mydays on login');
      });
    }
  }, [isLoggedIn]);

  if (isPending) return <div>{t('common.loading')}</div>;
  console.log('isLoggedIn: ', isLoggedIn);
  return (
    <div>
      {isLoggedIn && <Navbar />}
      {!isLoggedIn ? <Login /> : <RenderUserInfo />}
      <CookieConsent
        location="bottom"
        cookieName="MydayCookieConsent"
        style={{ background: '#2B373B' }}
        buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
        expires={150}
      >
        {t('common.cookieConsent')}
      </CookieConsent>
    </div>
  );
};

export default Home;
